import { ParaWeb, Environment } from '@getpara/react-sdk';

const constructorOpts = {
	emailPrimaryColor: '#ff6700',
	githubUrl: 'https://github.com/BloomNetwork',
	linkedinUrl: 'https://www.linkedin.com/company/bloom-network/',
	xUrl: 'https://x.com/ourbloomnetwork',
	homepageUrl: 'https://bloomnetwork.earth',
	supportUrl: 'https://bloomnetwork.earth'
};

export const paraClient = import.meta.env.VITE_IS_PRODUCTION
	? new ParaWeb(Environment.PROD, import.meta.env.VITE_PARA_API_KEY_PROD, constructorOpts)
	: new ParaWeb(Environment.DEV, import.meta.env.VITE_PARA_API_KEY_DEV, constructorOpts);
